module.exports = __webpack_public_path__ + "static/img/proyectos.c83544f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proyectos.jpg
// module id = P/th
// module chunks = 47